import React from 'react';
import { TextField } from '@mui/material';
import { SurveyComponent } from '../../../../models/SurveyTemplates';

interface TimePickerFieldProps {
    field: SurveyComponent;
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
}

const TimePickerField: React.FC<TimePickerFieldProps> = ({
    field,
    value = '',
    onChange,
    disabled = false
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(e.target.value);
    };

    return (
        <TextField
            type="time"
            value={value}
            onChange={handleChange}
            disabled={disabled}
            fullWidth
            variant="outlined"
            size="small"
            InputLabelProps={{
                shrink: true,
            }}
            placeholder={field.placeholder}
        />
    );
};

export default TimePickerField;
